import React from 'react';
import {
  DatePickerProps,
  DateTimePicker,
  DateTimePickerProps,
  DatePicker as MUIDatePicker,
} from '@mui/x-date-pickers';

type CommonProps = {
  label: string;
  errorMessage?: string;
};

type Props = CommonProps &
  (({ dateOnly?: false } & DateTimePickerProps<any>) | ({ dateOnly: true } & DatePickerProps<any>));

export const DatePicker = React.forwardRef<HTMLInputElement, Props>(
  ({ label, errorMessage, disablePast = true, dateOnly = false, ...props }, ref) => {
    const PickerComponent = dateOnly ? MUIDatePicker : DateTimePicker;
    return (
      <PickerComponent
        inputRef={ref}
        label={label}
        disablePast={disablePast}
        closeOnSelect={false}
        ampm={dateOnly ? undefined : false}
        // @ts-ignore - Allow for dateOnly prop
        slotProps={{
          textField: {
            helperText: errorMessage,
            error: !!errorMessage,
          },
        }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        sx={{ ...props.sx, margin: 0, width: '100%' }}
      />
    );
  },
);
DatePicker.displayName = 'DatePicker';
